import { defaultHttpClient } from '../../httpClient';

export const deletePoc = async (sno: number) => {
  return defaultHttpClient.request<void>({
    method: 'DELETE',
    url: `/api/v2/members/me/poc/${sno}/`,
  });
};
